import { apiSlice, asyncToastDisplay, i18n } from "./apiSlice";

export const streamApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getStreams: builder.query({
      query: () => `/streams/`,
      providesTags: (result, error, arg) => [{ type: 'Stream', id: 'LIST' }],
    }),
    getStream: builder.query({
      query: (streamKey) => `/streams/${streamKey}`,
      providesTags: (result, error, arg) => [{ type: 'Stream', id: arg }],
    }),
    getStreamAnalytics : builder.query({
      query: (streamKey) => `/streams/${streamKey}/stats`
    }),
    createStream: builder.mutation({
      query: (stream) => ({
        url: `/streams/`,
        method: 'POST',
        body: stream
      }),
      onQueryStarted: asyncToastDisplay({successMessage: i18n.t("toast.created")}),
      invalidatesTags: (result, error, arg) => [{ type: 'Stream', id: 'LIST' }],
    }),
    updateStream: builder.mutation({
      query: (stream) => ({
        url: `/streams/${stream.key}`,
        method: 'PUT',
        body: stream,
      }),
      onQueryStarted: asyncToastDisplay({successMessage: i18n.t("toast.updated")}),
      invalidatesTags: (result, error, arg) => [
        { type: 'Stream', id: arg.key },
        { type: 'Stream', id: 'LIST' }
      ]
    }),
  }),
  overrideExisting: false
})

export const {
  useGetStreamsQuery,
  useGetStreamQuery,
  useGetStreamAnalyticsQuery,
  useCreateStreamMutation,
  useUpdateStreamMutation
} = streamApiSlice
